import React from 'react'
import { ReactComponent as LibraryNull } from './library-null.svg'
import { Text } from '@trivie/ui-web/components/text'
import { color } from '@trivie/ui-web/theme'

export const NullState = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignContent: 'center',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <LibraryNull style={{ width: 400, height: 400 }} />
      <Text
        variant="body1Medium"
        text="You don't have anything assigned to you yet. When you do, you can browse through your learning content here."
        style={{ width: 400, textAlign: 'center', color: color.shade50 }}
      />
    </div>
  )
}
